import {AxiosResponse} from 'axios';
import {EntityService} from '../backend/interfaces/entity-service';
import {PostEntityService} from '../backend/requests/post-entity-service';
import {PutEntityService} from '../backend/requests/put-entity-service';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityServicesRepository {
  // Singleton Instance
  private static _instance: EntityServicesRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityServicesRepository {
    if (!this._instance) {
      this._instance = new EntityServicesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityServicesRepository');
  }

  // Get all services in an entity
  public async getInEntity(
    entityId: string,
    limit: number,
    skip: number,
    titleSearch?: string
  ): Promise<{totalCount: number; data: Array<EntityService>}> {
    // Set url
    let url: string = `/entity-services?entityId=${entityId}&limit=${limit}&skip=${skip}`;

    // Check text search
    if (titleSearch && titleSearch.trim().length !== 0) {
      // Add to the url
      url += `&title=${titleSearch}`;
    }

    // Get services from backend
    const result: AxiosResponse<Array<EntityService>> =
      await BackendApiManager.instance.get<Array<EntityService>>(url);

    // Return
    return {data: result.data, totalCount: parseInt(result.headers['x-total-count'] || '', 10)};
  }

  // Create a service
  public async create(model: PostEntityService): Promise<EntityService> {
    // Create the service in the backend
    const result: AxiosResponse<EntityService> =
      await BackendApiManager.instance.post<EntityService>('/entity-services', model);

    // Done
    return result.data;
  }

  // Get a service by id
  public async getById(id: string): Promise<EntityService> {
    // Get the service from the backend
    const result: AxiosResponse<EntityService> =
      await BackendApiManager.instance.get<EntityService>(`/entity-services/${id}`);

    // Done
    return result.data;
  }

  // Update a service
  public async updateById(id: string, model: PutEntityService): Promise<EntityService> {
    // Update the service in the backend
    const result: AxiosResponse<EntityService> =
      await BackendApiManager.instance.put<EntityService>(`/entity-services/${id}`, model);

    // Done
    return result.data;
  }

  // Delete a service
  public async deleteById(id: string): Promise<void> {
    // Get the service from the backend
    await BackendApiManager.instance.delete(`/entity-services/${id}`);
  }
}
